import React, { useEffect, useState } from "react";
import Pagination from "@mui/material/Pagination";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";

import Typography from "../../../../Typography";
import FieldContainer from "../../../../FieldContainer/FieldContainer";
import { groupBy } from "../../../../../utils/groupBy";

import { ReactComponent as CloseIcon } from "../../../../../build/images/close-circle.svg";
import { ReactComponent as ArrowBackIcon } from "../../../../../build/images/arrow_back.svg";
import { ReactComponent as ChevronLeftIcon } from "../../../../../build/images/nps-dashboard-icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "../../../../../build/images/nps-dashboard-icons/chevron-right.svg";

import "./user-history.css";
import {
  getDealHistoricCall,
  getDealHistoricCallV2,
} from "../../../../../actions";
import { compareAsc, parse } from "date-fns";

export default function UserHistory({
  userHistoryDrawer,
  onCloseDrawer,
  treatmentData,
  onSearch,
  interactionPhone,
  isCSAT = false,
}) {
  const itemsPerPageOptions = [5, 10, 20];
  const [userHistory, setUserHistory] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(itemsPerPageOptions[0]);
  const [currentPage, setCurrentPage] = useState(1);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = userHistory.slice(indexOfFirstItem, indexOfLastItem);

  const hasUserHistory = !!userHistory && userHistory.length > 0;

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(event.target.value);
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  function getBackgroundColor(npsNote) {
    //verifica se não for CSAT ele define a cor de acordo com a nota, se for ele pega a cor do parâmetro cor_conceito
    if (!isCSAT) {
      if (npsNote >= 0 && npsNote <= 6) {
        return "#c90000";
      } else if (npsNote === 7 || npsNote === 8) {
        return "#F2BD00";
      } else if (npsNote === 9 || npsNote === 10) {
        return "#008908";
      } else {
        return "#c90000";
      }
    } else {
      return treatmentData.cor_conceito
        ? treatmentData.cor_conceito
        : "#008908";
    }
  }

  function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return "";

    const ddd = phoneNumber.substring(0, 2);
    const number = phoneNumber.substring(2);

    return `(${ddd}) ${number}`;
  }

  useEffect(() => {
    const fetchData = async () => {
      const response = await getDealHistoricCall(
        onSearch ? interactionPhone : treatmentData.numero_cliente
      );
      //const response = await getDealHistoric(onSearch ? interactionPhone : treatmentData.numero_cliente);

      if (response.status !== 200) return;

      if (response.status === 200) setUserHistory(response.data);
    };

    const fetchDataV2 = async () => {
      let updatedUserHistory = [];
      const response = await getDealHistoricCallV2(
        onSearch ? interactionPhone : treatmentData.numero_cliente
      );

      const hasResponse = !!response && response.status === 200;
      if (hasResponse) {
        const data = response.data;
        const hasData = !!data && data.length > 0;
        if (hasData) {
          const groupedData = groupBy(data, "id_atendimento");
          const hasGroupedData = !!groupedData;
          if (hasGroupedData) {
            for (let id_atendimentoStr in groupedData) {
              let id_atendimento = id_atendimentoStr;
              let data_atendimento = "";
              let atendente = "";
              let id_midia = "";
              let desc_midia = "";
              let servico = "";
              let fechado = "";
              let nome_grupo = "";
              let nota_nps = "";
              let perfil_nps = "";
              let nota_csat = "";
              let perfil_csat = "";
              let nome_contato = "";
              let numero_cliente = "";

              const arraysWithAllData = groupedData[id_atendimentoStr];
              const hasArraysWithAllData =
                !!arraysWithAllData && arraysWithAllData.length > 0;
              if (hasArraysWithAllData) {
                arraysWithAllData.forEach((datum, index) => {
                  const isFirstData = index === 0;
                  if (isFirstData) {
                    id_atendimento = datum.id_atendimento;
                    data_atendimento = datum.data_atendimento;
                    atendente = datum.atendente;
                    id_midia = datum.id_midia;
                    desc_midia = datum.desc_midia;
                    servico = datum.servico;
                    fechado = datum.fechado;
                    nome_grupo = datum.nome_grupo;
                    nome_contato = datum.nome_contato;
                    numero_cliente = datum.numero_cliente;
                  }

                  const hasNpsInfos = !!datum.nota_nps || datum.nota_nps === 0;
                  if (hasNpsInfos) {
                    nota_nps = datum.nota_nps;
                    perfil_nps = datum.perfil_nps;
                  }

                  const hasCsatInfos =
                    !!datum.nota_csat || datum.nota_csat === 0;
                  if (hasCsatInfos) {
                    nota_csat = datum.nota_csat;
                    perfil_csat = datum.perfil_csat;
                  }
                });
              }

              updatedUserHistory.push({
                id_atendimento,
                data_atendimento,
                atendente,
                id_midia,
                desc_midia,
                servico,
                fechado,
                nome_grupo,
                nota_nps,
                perfil_nps,
                nota_csat,
                perfil_csat,
                nome_contato,
                numero_cliente,
              });
            }
          }
        }
      }

      const hasDataInUpdatedUserHistory =
        !!updatedUserHistory && updatedUserHistory.length > 0;
      if (hasDataInUpdatedUserHistory) {
        const dateFormat = "dd/MM/yyyy HH:mm:ss";

        updatedUserHistory.sort((a, b) => {
          let dateA = new Date();
          let dateB = new Date();
          try {
            dateA = parse(a.data_atendimento, dateFormat, new Date());
            dateB = parse(b.data_atendimento, dateFormat, new Date());
          } catch (error) {
            console.log(error);
          }

          return compareAsc(dateA, dateB);
        });
      }

      setUserHistory(updatedUserHistory);
    };

    fetchDataV2();
  }, []);

  return (
    <div
      className={`user-history-container ${userHistoryDrawer ? "" : "closed"}`}
    >
      <header className="user-history-container__header">
        <div>
          <ArrowBackIcon onClick={onCloseDrawer} />

          <Typography.H1 color="blue-selected-4" weight={700}>
            Histórico do usuário
          </Typography.H1>
        </div>

        <button
          className="user-history-container__header__close"
          onClick={onCloseDrawer}
        >
          <CloseIcon />
        </button>
      </header>

      <main className="user-history-container__content">
        <section className="user-history-section1">
          <div className="user-history-section1__content">
            <div
              className="user-history-section1__content__number"
              style={{
                backgroundColor: getBackgroundColor(
                  treatmentData.nota_nps || treatmentData.note
                ),
              }}
            >
              <Typography.H1 weight="700" color="white">
                {treatmentData.nota_nps || treatmentData.note}
              </Typography.H1>
            </div>

            <div className="user-history-section1__content__phone-and-user">
              {hasUserHistory && (
                <Typography.H2 weight="700" color="gray-180">
                  {userHistory[0].nome_contato}
                </Typography.H2>
              )}

              <Typography.H5 weight="400" color="gray-180">
                {formatPhoneNumber(
                  treatmentData.numero_cliente || treatmentData.phone
                )}
              </Typography.H5>
            </div>
          </div>
        </section>

        <section className="user-history-section2">
          <Typography.H5 weight="500" color="gray-180">
            Dados do atendimento
          </Typography.H5>

          <div className="user-history-section2__cards">
            {currentItems.map((card, index) => {
              const hasNpsGrade = !!card.nota_nps || card.nota_nps === 0;
              const hasNpsProfile = !!card.perfil_nps;
              const hasCsatGrade = !!card.nota_csat || card.nota_csat === 0;
              const hasCsatProfile = !!card.perfil_csat;

              return (
                <div
                  key={index}
                  className="card-content card-content-call-center"
                >
                  <FieldContainer
                    className="card-content__field-container"
                    title="Data e hora"
                  >
                    <Typography.H5 weight="500" color="gray-180">
                      {card.data_atendimento}
                    </Typography.H5>
                  </FieldContainer>
                  <FieldContainer
                    className="card-content__field-container"
                    title="Serviço"
                  >
                    <Typography.H5 weight="500" color="gray-180">
                      {card.servico ? card.servico : ""}
                    </Typography.H5>
                  </FieldContainer>
                  <FieldContainer
                    className="card-content__field-container"
                    title="Grupo"
                  >
                    <Typography.H5 weight="500" color="gray-180">
                      {card.nome_grupo ? card.nome_grupo : ""}
                    </Typography.H5>
                  </FieldContainer>
                  <FieldContainer
                    className="card-content__field-container"
                    title="Nota CSAT"
                  >
                    <Typography.H5 weight="500" color="gray-180">
                      {hasCsatGrade ? card.nota_csat : "-"}
                    </Typography.H5>
                  </FieldContainer>
                  <FieldContainer
                    className="card-content__field-container"
                    title="Perfil CSAT"
                  >
                    <Typography.H5 weight="500" color="gray-180">
                      {hasCsatProfile ? card.perfil_csat : "-"}
                    </Typography.H5>
                  </FieldContainer>
                  <FieldContainer
                    className="card-content__field-container"
                    title="Nota NPS"
                  >
                    <Typography.H5 weight="500" color="gray-180">
                      {hasNpsGrade ? card.nota_nps : "-"}
                    </Typography.H5>
                  </FieldContainer>
                  <FieldContainer
                    className="card-content__field-container"
                    title="Perfil NPS"
                  >
                    <Typography.H5 weight="500" color="gray-180">
                      {hasNpsProfile ? card.perfil_nps : "-"}
                    </Typography.H5>
                  </FieldContainer>
                  <FieldContainer
                    className="card-content__field-container"
                    title="Atendente"
                  >
                    <Typography.H5 weight="500" color="gray-180">
                      {card.atendente}
                    </Typography.H5>
                  </FieldContainer>
                </div>
              );
            })}

            <div className="user-history-section2__cards__pagination-container">
              <Typography.H5 weight="500" color="gray-180">
                Linha por página:
              </Typography.H5>
              <Select
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                variant="standard"
                className="pagination-select"
              >
                {itemsPerPageOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>

              <Typography.H5 weight="500" color="gray-180">
                Mostrando {indexOfFirstItem + 1}-
                {Math.min(indexOfLastItem, userHistory.length)} de{" "}
                {userHistory.length} itens
              </Typography.H5>

              <Pagination
                count={1}
                page={currentPage}
                onChange={handlePageChange}
                renderItem={(item) => {
                  switch (item.type) {
                    case "previous":
                      return (
                        <IconButton
                          onClick={() =>
                            handlePageChange(null, currentPage - 1)
                          }
                          disabled={currentPage === 1}
                          className="icon-buttom"
                        >
                          <ChevronLeftIcon />
                        </IconButton>
                      );
                    case "next":
                      return (
                        <IconButton
                          onClick={() =>
                            handlePageChange(null, currentPage + 1)
                          }
                          disabled={
                            currentPage ===
                            Math.ceil(userHistory.length / itemsPerPage)
                          }
                          className="icon-buttom"
                        >
                          <ChevronRightIcon />
                        </IconButton>
                      );
                    default:
                      return null;
                  }
                }}
                className="pagination"
              />

              {/* <Pagination
                                count={Math.ceil(cardContentData.length / itemsPerPage)}
                                page={currentPage}
                                onChange={handlePageChange}
                                variant="outlined"
                                shape="rounded"
                                className="pagination"
                            /> */}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
